import { TbLanguage } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const stringsRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.STRINGS,
        meta: {
            label: "strings",
            order: 8,
            icon: TbLanguage,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.APP_STRINGS_LIST],
        },
    },
];
